@use '@lib/assets/styles/main.scss' as *;

.steps {
  padding: 24px 24px 24px 56px;
  background: $gray10;
  box-shadow: 0 2px 3px 0 rgba($gray1000, 0.15);
  position: relative;
  z-index: 3;
}

.stepsGrid {
  min-width: 728px;
  display: inline-flex;
  align-items: center;
  justify-content: space-between;
  position: relative;
  margin: 0 -18px;
  &::before {
    content: '';
    background: $gray200;
    height: 1px;
    position: absolute;
    top: 50%;
    left: 0;
    right: 0;
    transform: translateY(-50%);
  }
}

.step {
  position: relative;
  background: $gray10;
  border: none;
  text-align: left;
  padding: 0 18px;
}

.stepGrid {
  position: relative;
  padding-left: 48px;
  min-height: 40px;
  display: flex;
  align-items: center;
}

.stepNumber {
  position: absolute;
  top: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  color: $gray0;
  background: $disable500;
  border-radius: 50%;

  .stepActive &,
  .stepCompleted & {
    background: $blue500;
  }
}

.stepTitle {
  display: flex;
  align-items: center;
  gap: 4px;
}

.stepOptional {
  color: $gray400;
  margin-top: 2px;
  text-transform: capitalize;
}

.stepErrorCount {
  display: block;
  background: $error900;
  color: $gray0;
  width: 20px;
  height: 20px;
  line-height: 20px;
  text-align: center;
  border-radius: 50%;
}
